import { CompanyStatusEnum } from '../models';

export const companyStatus: { [key in CompanyStatusEnum]: CompanyStatusEnum } =
  {
    active: 'active',
    disabled: 'disabled',
    pending: 'pending',
    rejected: 'rejected',
  };

export const companyStatusTranslate = {
  active: 'aceptado',
  disabled: 'deshabilitado',
  pending: 'pendiente',
  rejected: 'rechazado',
};
